import React, { useState } from 'react'
import { ContactMap } from './assets/ContactMap'
import { LocationDetails } from './assets/LocationDetails'
import { AdditionalContactInfo } from './assets/AdditionalContactInfo'
import { GeneralContactInfo } from './assets/GeneralContactInfo'
import { ContactPageFormApp } from '../../../CrmForms'
import { useTranslation, TranslationsProvider } from '../../../../general'

const ContactPageContent = () => {
  const { locale } = useTranslation()
  const [isMapOpen, setIsMapOpen] = useState(false)
  
  if (locale !== 'ro') {
    return <GeneralContactInfo />
  }

  return (
    <div className="contct-page my-3 md:my-10">
      <h2 className="text-[#584B53] font-montserrat text-[23px] font-bold p-4">
        Contact
      </h2>
      <div className="contact-page__container">
        <div className="contact-page__top">
          <div className="md:hidden">
            <button
              className={`w-full flex items-center justify-between px-5 py-3 focus:outline-none border border-contact-gray bg-contact-bg ${isMapOpen ? 'shadow-contact-shadow' : ''}`}
              onClick={() => setIsMapOpen(!isMapOpen)}
              type="button"
              aria-expanded={isMapOpen}
            >
              <span className={`text-[20px] font-montserrat ${isMapOpen ? 'text-accent-green font-bold' : 'text-custom-gray font-bold'}`}>
                Adrese sedii
              </span>
              <span className="text-[32px] font-montserrat font-bold">{isMapOpen ? '-' : '+'}</span>
            </button>
            {isMapOpen && (
              <div className="border border-contact-gray bg-contact-bg shadow-contact-shadow mt-[28px] mb-[28px] pb-[40px]">
                <ContactMap />
              </div>
            )}
          </div>
          <div className="hidden md:block mb-5">
            <ContactMap />
          </div>
        </div>
        <div className="contact-page__bottom flex flex-col md:flex-row items-start justify-start gap-5 xl:gap-20">
          <div className="w-full md:w-1/2">
            <AdditionalContactInfo />
            <ContactPageFormApp />
          </div>
          <div className="w-full md:w-1/2">
            <LocationDetails />
          </div>
        </div>
      </div>
      <p className="text-center text-[#888] text-[14px] mt-10 mb-2 px-2 max-w-[800px] mx-auto">
        Site-ul <a href="/" className="underline hover:text-main-orange active:text-text-gray visited:text-text-gray text-text-gray">Magazia Lu' Costica</a> este operat de Keiron Logistics S.R.L., avand sediul in Str. Strandului nr. 70, Ploiesti J29/3417/1994, CUI: RO6697285, Capital Social: <strong>500.000</strong> RON, Cont BRD: RO47 BRDE 300S V081 7989 3000, Numar notificare ANSPDCP: 32928.
      </p>
    </div>
  )
}

export const ContactPage: React.FC = () => {
  return (
    <TranslationsProvider>
      <ContactPageContent />
    </TranslationsProvider>
  )
}
